// extracted by mini-css-extract-plugin
export var select = "anchorSelect-module--select--1tp_s";